// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--xguro7lhcqs6Zp4T"};